// extracted by mini-css-extract-plugin
export default {"toggle":"HuvxpO","track":"CpN2hc","checked":"bTnPwC","thumb":"YdqGCH","check":"YLmNQu","cross":"g70_d1"};